import { EnterpriseQuotePortalService } from './enterprise-quote-portal-service';
import { queryClient } from '../query-client';
export const enterpriseQuotePortalService = new EnterpriseQuotePortalService({
    resource: 'enterprise-quote-portal',
    parentResources: [],
    middleware: [],
    queryClient,
});
